<script setup lang="ts">
import { useBoothModal } from "@/lib/use-booth-modal"
import { toBooth } from "~/lib/booth";

const name = "芸術学部展"

definePageMeta({
  title: "展示・模擬店 - 芸術学部"
})

const modal = useBoothModal()
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px]">
    <XlsxData :path="`/data/booth/${name}.xlsx`" :transformer="data => toBooth(name, data)" >
      <template #default="{ data }">
        <div class="grid gap-4 grid-cols-1 md:grid-cols-2 mb-8">
          <template v-for="(booth, i) in data">
            <BoothItem
              :data="booth" 
              :index="i"
              @click="() => {
                modal.index = i
              }"
            />
          </template>
        </div>
        <ClientOnly>
          <BoothModal 
            v-model="modal.model" 
            :index="modal.index"
            :data="data[modal.index!]"
            :key="modal.index"
          />
        </ClientOnly>
      </template>
    </XlsxData>

    <div class="mb-4">
      <NuxtLink class="btn btn-primary" to="/booth">
        前のページに戻る
      </NuxtLink>
    </div>
  </article>
</template>